import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import StructuredData from "../components/StructuredData";

const ContactPage = () => {
  // Scroll to top when the page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="overflow-hidden">
      <SEO 
        title="Contact Us - Get in Touch"
        description="Contact Safir Elite for inquiries about courses, enrollment, or partnerships. We're here to help you achieve educational excellence."
        canonical="/contact"
        ogType="website"
        keywords="contact, Safir Elite, inquiries, enrollment, Afghanistan, Kabul, educational center"
      />
      <StructuredData type="WebSite" />
      <Navbar />
      <div className="pt-0"> {/* Add padding to account for fixed navbar */}
        <ContactSection />
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;